import Vue from 'vue';
import store from '../../store/index';

export default {
  namespaced: true,
  state: {
    filterOptions: [
      [
        {id: 'equals', text: 'Equals...', value: '=', disabled: false},
        {id: 'does-not-equal', text: 'Does not equal...', value: '!=', disabled: false},
      ],
      [
        {id: 'less-than', text: 'Less than...', value: '<', disabled: false},
        {id: 'less-than-or-equal-to', text: 'Less than or equal to...', value: '<=', disabled: false},
        {id: 'greater-than', text: 'Greater than...', value: '>', disabled: false},
        {id: 'greater-than-or-equal-to', text: 'Greater than or equal to...', value: '>=', disabled: false},
      ],
      [
        {id: 'contains', text: 'Contains...', value: '*', disabled: false},
        {id: 'starts-with', text: 'Starts with...', value: '^', disabled: false},
        {id: 'ends-with', text: 'Ends with...', value: '$', disabled: false},
        {id: 'does-not-contain', text: 'Does not contain...', value: '!*', disabled: false},
      ],
    ],
    filterOptionsText: {
      '=': 'Equals',
      '!=': 'Does not equal',
      '<': 'Less than',
      '<=': 'Less than or equal to',
      '>': 'Greater than',
      '>=': 'Greater than or equal to',
      '*': 'Contains',
      '^': 'Starts with',
      '$': 'Ends with',
      '!*': 'Does not contain',
      '~': 'Similar to',
      'from': 'From',
      'to': 'To',
    },
    permissionTypes: {
      none: 'none',
      read: 'read',
      write: 'write',
    },
    allDataLoaded: false,
    menuCollapsed: false,
    menuHidden: false,
    menuPin: false,
    /**
     * Key is the name of the menu item and value is MenuItem class instance
     */
    _menuItems: {},
    isFourthVersion: false,
  },
  getters: {
    menuItems: state => Object.values(state._menuItems)
      .filter((item) => {
        if (['Connector Screen', 'Sun Model', 'System Info', 'File Manipulation Controller', 'Orchestration', 'Monitoring'].includes(item.uuid)) {
          return store.getters['dataManagement/isAdmin'];
        }
        return item.permission !== state.permissionTypes.none;
      })
      .sort((a, b) => a.weight - b.weight),
  },
  actions: {
    addMenuItem({commit}, {name, menuItem}) {
      commit('ADD_MENU_ITEM', {name, menuItem});
    },
    removeMenuItem({commit}, name) {
      commit('REMOVE_MENU_ITEM', name);
    },
    toggleMenuCollapse({commit, state}) {
      commit('TOGGLE_MENU_COLLAPSE', !state.menuCollapsed);
    },
    toggleMenuHide({commit, state}) {
      commit('TOGGLE_MENU_HIDE', !state.menuHidden);
    },
    toggleMenuPinned({commit}, payload) {      
      commit('TOGGLE_MENU_PIN', payload);
    },
    changeVersion({commit}, version){
      commit('CHANGE_VERSION', version);
    },
  },
  mutations: {
    SET_ALL_DATA_LOADED: state => state.allDataLoaded = true,
    TOGGLE_MENU_HIDE: (state, hide) => state.menuHidden = hide,
    TOGGLE_MENU_COLLAPSE: (state, collapse) => state.menuCollapsed = collapse,
    TOGGLE_MENU_PIN: (state, pin) => state.menuPin = pin,
    ADD_MENU_ITEM: (state, {name, menuItem}) => {
      state._menuItems = {
        ...state._menuItems,
        [name]: menuItem,
      };
    },
    REMOVE_MENU_ITEM: (state, name) => {
      Vue.delete(state._menuItems, name);
    },
    CHANGE_VERSION: (state, payload ) => { 
      state.isFourthVersion = payload;
    },
  },
};
